import React, { useState } from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import Button from "@src/components/atoms/Button";
import Form from "@src/components/forms/Form";
import FormInput from "@src/components/atoms/FormInput";
import CardContainer from "@src/components/cards/CardContainer";
import { REQUIRED_FIELD_MESSAGE } from "@src/constants/constants";

export function ImpersonateLoginForm({
  impersonateIdentityProfile,
  customerCode,
  error,
}) {
  const [username, setUsername] = useState("");
  const [loginSubmitting, setLoginSubmitting] = useState(false);
  const [loginSubmitted, setLoginSubmitted] = useState(false);
  const [internalError, setInternalError] = useState(null);

  const handleSubmitImpersonate = async () => {
    console.log("Impersonate Login Form submitted with username:", username);
    // Call the impersonateIdentityProfile function asynchronously
    if (!username.trim()) {
      setInternalError(REQUIRED_FIELD_MESSAGE);
      return;
    }
    setLoginSubmitting(true);
    error = "";
    setInternalError(null);
    try {
      await impersonateIdentityProfile({
        username: username.trim().toLowerCase(),
        customerCode,
      });
      setLoginSubmitted(true);
    } catch (e) {
      setInternalError(
        `Failed to impersonate user. Please check the username and try again. (${JSON.stringify(e)})`,
      );
      console.error("Impersonate login error", e);
    } finally {
      setLoginSubmitting(false);
    }
  };

  if (loginSubmitted && !error && !internalError) {
    return (
      <CardContainer>
        <h5 className="text-primary-500">
          Please wait until you are redirected...
        </h5>
      </CardContainer>
    );
  }

  return (
    <>
      <CardContainer shadow={false}>
        <h3 className="text-center text-2xl font-bold my-4">
          Log into {customerCode} as user
        </h3>

        <Form onSubmit={handleSubmitImpersonate} className="space-y-6">
          {(methods) => {
            return (
              <>
                <div className="m-4">
                  <FormInput
                    label="username"
                    name="username"
                    type="text"
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder={`Username or Email address (captain@${customerCode}.com)`}
                    error={methods.formState.errors.username?.message}
                    textColor={"primary"}
                  />
                  {error != null && (
                    <div className="mt-4 text-xs italic text-red-500">
                      {error}
                    </div>
                  )}
                  {internalError != null && (
                    <div className="mt-4 text-xs italic text-red-500">
                      {internalError}
                    </div>
                  )}
                </div>
                <Button submit loading={loginSubmitting}>
                  {" "}
                  <div className="px-4">Log in</div>
                </Button>
              </>
            );
          }}
        </Form>
      </CardContainer>
    </>
  );
}

export const ImpersonateLoginFormControls = {
  customerCode: {
    controlType: "Text",
    description: "Type of login: Guest, Email Address, Username",
  },
  impersonateIdentityProfile: {
    propType: PropTypes.func.isRequired,
    description: "Form submission handler from parent",
    disable: true,
  },
};

ImpersonateLoginForm.propTypes = AppUtils.getPropTypeFromControls(
  ImpersonateLoginFormControls,
);

export default ImpersonateLoginForm;
